<template>
    <div>
        <md-tabs md-sync-route>
            <md-tab id="tab-bills-contracts" md-label="Facturation contrats" to="contract" exact>
                <contracts-index v-if="this.$route.path.slice(15) === 'contract'"></contracts-index>
            </md-tab>
            <md-tab id="tab-bills-interventions" md-label="Facturation inters" to="intervention">
                <interventions-index v-if="this.$route.path.slice(15) === 'intervention'"></interventions-index>
            </md-tab>
        </md-tabs>
    </div>
</template>

<script>
import ContractsIndex from "./components/ContractsIndex";
import InterventionsIndex from "./components/InterventionsIndex";

export default {
    name: "Bills",
    components: {
        ContractsIndex,
        InterventionsIndex
    }
}
</script>

<style scoped lang="scss">
::v-deep {
    .md-tabs {
        .md-tabs-navigation {
            margin: 10px 0;
            background: #fff !important;
            padding: 0;
            transition: all 150ms ease-in;
            -webkit-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);
            box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);

            .md-tab-nav-button {
                background: transparent !important;
                color: rgba(0, 0, 0, 0.87) !important;
                min-width: max-content;

                :hover {
                    background: rgba(200, 200, 200, 0.2) !important;
                }

                .md-button-content:hover {
                    background: unset !important;
                }

                &.md-active {
                    border-bottom: 2px solid #dd4b39 !important;
                }
            }
        }

        .md-content {
            background: transparent !important;

            table {
                thead {
                    display: contents;
                }
            }

            .md-tab {
                padding: 0;
            }
        }
    }
}
</style>

